import React, {FC} from "react";
import {ScoreType, TargetType} from "../types/types";
import {isMobile} from "react-device-detect";
import {Bridge} from "../plugins/bridge";
import {scoreUp} from "../apis/score";
// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/navigation/navigation.min.css';
// import Swiper core and required modules
import SwiperCore, {Navigation, Keyboard, Autoplay} from 'swiper/core';
SwiperCore.use([Navigation, Keyboard, Autoplay]);

const StoreData = [
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-thehyundai-resized.jpg',
    url:'thehyundaidetail',
    text:'칼하트윕 더현대 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-sinsa.jpg',
    url:'sinsadetail',
    text:'칼하트윕 신사 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/media.worksout.co.kr/resized/outlets/store-carhartt-13_resized.jpg',
    url:'lottedetail',
    text:'칼하트윕 롯데월드몰 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-apgujeong.jpeg',
    url:'apgujeongdetail',
    text:'칼하트윕 압구정 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-hongdae.jpeg',
    url:'hongdaedetail',
    text:'칼하트윕 홍대 와우산 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/media.worksout.co.kr/resized/outlets/store-carhartt-14.jpg',
    url:'coexdetail',
    text:'칼하트윕 코엑스 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-time.jpeg',
    url:'timedetail',
    text:'칼하트윕 타임스퀘어 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-cheonan.jpg',
    url:'cheonandetail',
    text:'칼하트윕 천안 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-gwangju.jpg',
    url:'gwangjudetail',
    text:'칼하트윕 광주 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-jeonju.jpeg',
    url:'jeonjudetail',
    text:'칼하트윕 전주 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-daegu.jpeg',
    url:'daegudetail',
    text:'칼하트윕 대구 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-dongseongro.jpeg',
    url:'dongseongrodetail',
    text:'칼하트윕 동성로 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-jeju.jpeg',
    url:'jejudetail',
    text:'칼하트윕 제주 스토어',
  },
  {
    ImgUrl:'https://s3.ap-northeast-2.amazonaws.com/media.worksout.co.kr/resized/outlets/store-carhartt-10-7.jpg',
    url:'centumdetail',
    text:'칼하트윕 부산 센텀시티 스토어',
  },

];

export interface StoreSliderProps {
  slidesPerView:number
}

export const StoreSlider: FC<StoreSliderProps> = ({
  slidesPerView
}) => {
  const handleContentClick = async (Data: any, index: number) => {
    if (Data.url) {
      window.open(`/${Data.url}`, '_parent');
      Bridge.sendAmplitude('main_content_clicked', { content_id: index, content_name: Data.text });
      await scoreUp(+Data.id, TargetType.CONTENT, ScoreType.VIEW);
    }
  };

  return (
        <Swiper
            loop={true}
            navigation={false}
            pagination={false}
            slidesPerView={isMobile ? (1) : (slidesPerView)}
            keyboard={{
              enabled: true
            }}
            autoplay={{
              delay: 3000,
            }}
            watchOverflow={true}
        >
          {StoreData.map((Data, index) => {
            return (
                <SwiperSlide
                    onClick={() => handleContentClick(Data, index)}
                    key={index}
                    className={`mainStore relative cursor-pointer`}
                >
                  <div className={`mainStoreText duration-300 absolute text-white p-4`}>
                    {Data.text}
                  </div>
                  <img className={`object-cover w-full h-full`} src={Data.ImgUrl}/>
                </SwiperSlide>
            )
          })}
        </Swiper>
  );
};